const victory = require('victory');
export default victory;